import { Progress } from '@mantine/core'
import SkeletonLoader from '@ospace/distribution-pipeline/components/SkeletonLoader'

export const DashboardLoader = ({ progress, total }: { progress: number; total: number }) => (
  <div aria-label='dashboard loader' style={{ margin: '-26px' }}>
    <Progress animated size='xs' value={((progress || 2) / (total || 5000)) * 100} />
    <SkeletonLoader />
  </div>
)
